import Blue from "~/core";

new Blue({
	name: 'Email Opt In',
	selector: ".email-opt-in",
	setup(container) {
		const form = container.querySelector(".email-opt-in__form");
		const submit = form.querySelector("input[type=submit]");
		const successMsg = container.querySelector(".email-opt-in__complete");

		const showSuccessMsg = () => {
			form.classList.add("hidden");
			successMsg.classList.add("showing");
		}

		this.$addEvents(submit, "click", showSuccessMsg);
	}
});